<template>
  <v-container>
    <v-row>
      <v-col cols="12" xs="12">
        <v-stepper v-model="e1" class="elevation-0" >
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1" color="black">
              Definition of the pollen sum
            </v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 1" step="2" color="black">
              Taxon selection
            </v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 1" step="3" color="black">
              Site selection
            </v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 1" step="4" color="black">
              Interval definition
            </v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 1" step="5" color="black">
              Output format
            </v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 1" step="6" color="black">
              Query recapitulation
            </v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 1" step="7" color="black">
              Query Result
            </v-stepper-step>

          </v-stepper-header>
        </v-stepper>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="9">
        <v-row>
          <router-view class="mx-5"></router-view>
        </v-row>
        <!-- <v-row justify="end">
          <v-btn disabled class="mr-5">Next step<v-icon right>mdi-send</v-icon></v-btn>
        </v-row> -->
      </v-col>

      <v-col cols="12" md="3">
        <v-card min-height="600px" flat>
          <v-card-title> Query recap </v-card-title>
          <v-card-text>
            
            <v-textarea height="500px" outlined :value="JSON.stringify(getState, null, 2)"></v-textarea>
            <v-divider></v-divider>
          </v-card-text>
        </v-card>
       <!--  <v-navigation-drawer width="100%">
          Eiii
        </v-navigation-drawer> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      e1:1
    };
  },
  methods: {


  },
  computed: {
    ...mapGetters("db_fossilpercentages", [
      "getState"
    ]),
  },

};
</script>

<style>
</style>